import { hasPlaceholders, placeholders } from "@/config/site";

// Development-only strip: impossible to forget invented figures at ship time.
// Hidden by default — flip window.__VENDRA_DEV_STRIP__ = true in the console
// to re-enable during a QA pass.
export default function PlaceholderGuard() {
  if (process.env.NODE_ENV === "production" || !hasPlaceholders) return null;
  if (typeof window !== "undefined" && !window.__VENDRA_DEV_STRIP__) return null;
  const keys = Object.keys(placeholders);
  return (
    <div
      className="pointer-events-none fixed bottom-0 left-0 right-0 z-[80] border-t border-gold/40 bg-ink/95 px-4 py-2 backdrop-blur-sm"
      data-testid="placeholder-guard"
      role="status"
    >
      <p className="font-mono text-[10px] leading-relaxed tracking-wide text-gold">
        DEV ONLY · {keys.length} placeholder values still in site.js:{" "}
        <span className="text-mutedText">{keys.join(" · ")}</span>
      </p>
    </div>
  );
}
